import React from 'react';
import { TariffKindInternal } from '../../../../../../data-access/gql-types/graphql';
import { useTariffConfigurationContext } from '../../../channel-configuration/context/tariff-configuration-context';
import { ChartDynamic } from './charts/chart-dynamic';
import { ChartG11 } from './charts/chart-g11';
import { ChartG13s } from './charts/chart-g13s';
import { ChartTariff } from './charts/chart-tariff';

export const TariffPresentation: React.FC = () => {
  const { selectedTariff } = useTariffConfigurationContext();

  const renderCurrentPrentation = () => {
    if (!selectedTariff) return null;

    if (selectedTariff.includes('_DYNAMIC')) return <ChartDynamic />;
    if (selectedTariff === TariffKindInternal.TauronG13S) return <ChartG13s />;
    if (selectedTariff.includes('11')) return <ChartG11 />;
    if (selectedTariff.length) return <ChartTariff />;

    return null;
  };

  return <div>{renderCurrentPrentation()}</div>;
};
